import { Navigate, Outlet } from 'react-router-dom';
import { hasPermissions } from './hasPermissions';

/**
 * Route guard that redirects to a fallback route if the user
 * does not have the required permission.
 *
 * Usage:
 * <Route element={<RequirePermission permission="project" level="read" />}>
 *   <Route path="projects/:id" element={<ShowProject />} />
 * </Route>
 */
export const RequirePermission = ({
  permission,
  level = null,
  redirectTo = '/',
}) => {
  if (!hasPermissions(permission, level))
    return <Navigate to={redirectTo} replace />;

  return <Outlet />;
};
